<div class="flex flex-col gap-2">
  <div class="flex flex-wrap items-center justify-between gap-2">
    <h3 class="text-sm text-proffeo-text">{{ 'cooperations.projects-in-cooperation' | translate }}</h3>
    @if (writable() && canEditProjects()) {
      <proffeo-ui-button
        (clicked)="openAddProjectsDialog()"
        [text]="'cooperations.add-projects' | translate"
        variant="secondary"
        class="!py-1 !text-sm"
      ></proffeo-ui-button>
    }
  </div>
  @if (!cooperationProjects()?.length) {
    <div
      class="w-full overflow-hidden rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface px-4 py-6 text-center text-sm text-proffeo-disabled"
    >
      {{ 'cooperations.no-projects-in-cooperation' | translate }}
    </div>
  } @else {
    @if (writable()) {
      <div class="w-full overflow-hidden rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface">
        <div
          class="grid grid-cols-[minmax(0,1fr)_auto] items-center bg-proffeo-surface-muted px-4 py-2 text-xs text-proffeo-muted"
        >
          <span>{{ 'cooperations.projects-table.columns.project' | translate }}</span>
          <span class="text-right">{{ 'cooperations.projects-table.columns.actions' | translate }}</span>
        </div>
        <ul class="divide-y divide-proffeo-border text-sm text-proffeo-text">
          @for (cp of cooperationProjects(); track cp.id) {
            <li class="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2 px-4 py-2">
              <span class="truncate">{{ cp.project()?.name ?? '—' }}</span>
              @if (canEditProjects() && cp.project()?.id) {
                <proffeo-ui-button
                  (clicked)="removeProject(cp.project()!.id)"
                  variant="ghost"
                  text="cooperations.remove-project"
                  class="justify-self-end !text-xs text-proffeo-danger hover:underline"
                />
              }
            </li>
          }
        </ul>
      </div>
    } @else {
      <div class="w-full overflow-hidden rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface">
        <div class="bg-proffeo-surface-muted px-4 py-2 text-xs text-proffeo-muted">
          {{ 'cooperations.projects-table.columns.project' | translate }}
        </div>
        <ul class="divide-y divide-proffeo-border text-sm text-proffeo-text">
          @for (cp of cooperationProjects(); track cp.id) {
            <li class="px-4 py-2">
              <span class="truncate">{{ cp.project()?.name ?? '—' }}</span>
            </li>
          }
        </ul>
      </div>
    }
  }
</div>
